import { PageContext } from './types'

export const page404WithoutContext: PageContext = {
  widgets: [],
  name: '404',
  url: '/404',
  metaTitlePhrase: undefined,
  breadcrumbs: [
    {
      phrase: ['Common', 'breadcrumb.homepage.text'],
      url: '/'
    }
  ]
}
